import React, { Component } from "react";
import { UserManagerTableDataWidget, AddUserWidget } from "../../../widgets";

const reducer = "UserManagerV3_reducer";

const tableDataSelectors = UserManagerTableDataWidget.createSelectors(reducer);
const addUserWidget = AddUserWidget.createSelectors(reducer);

export default class UserManagerV3 extends Component {
    render() {
        return (
            <React.Fragment>
                <AddUserWidget.view
                    selectors={addUserWidget}
                    userProfileKeys={this.props.userProfile}
                />
                <UserManagerTableDataWidget.view
                    selectors={tableDataSelectors}
                    tableConfig={this.props.tableConfig}
                />
            </React.Fragment>
        );
    }
}
